export const hasErrors = (errors) => {
    return Object.values(errors).find(x => !!x)
}

export const indexHasErrors = (errors, index) => {
    return Object.keys(errors).some(x => {
        let matchingKey = x.substring(0, String(index).length + 1)
        return matchingKey === `${index}.` && errors[x]
    })
}

export const clearError = (errors, field) => {
    errors = { ...errors }
    Object.assign(errors, { [field]: null });

    return errors
}

export const clearErrors = (errors) => {
    errors = { ...errors }

    Object.keys(errors).forEach((key) => {
        errors = clearError(errors, key)
    })

    return errors
};

export const parseErrors = (data) => {
    let resp = data.response.data
    if (resp.error_type !== 'form_validation') {
        return {}
    }

    let newErrors = {}

    for (const error of resp.errors) {
        if (error.field === 'global') {
            continue
        }

        newErrors[error.field] = error.error_message
    }

    return newErrors
}

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export default {
    clearError,
    clearErrors,
    hasErrors,
    parseErrors,
    validateEmail,
    indexHasErrors
}